import { positionMap } from '@/api';
import { get } from '@/common/request';

class PositionStore {
  positionSearch(keyword: string): Promise<any> {
    return get(positionMap.get('search'), { keyword }, { proxyApi: '/mirage', needHint: true });
  }
}

export default new PositionStore();
